import React from 'react';
import { Field } from 'redux-form';
import { BooleanInput, NumberInput, ReferenceArrayInput, SelectArrayInput, TextInput } from 'react-admin';
import { FormDataConsumer } from 'react-admin';
import { required } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import CanViewExperimentId from '../../../../Common/Partials/Helpers/CanViewExperimentId';
import CanViewExperimentName from '../../../../Common/Partials/Helpers/CanViewExperimentName';
import CommonSettings from '../../../../Common/Partials/Settings';
import { rtbDomainsDropdown } from '../../StaticData/Domains';
import PaceInputs from '../../../../Common/Partials/PaceInputs';

const ValidateRequired = required();

const styles = createStyles({
  bidders: {
    minWidth: 230
  }
});

type Props = {
  classes: any,
  permissions: any,
  record: any,
  resource: string
};

const SettingsTab = (props: Props) => (
  <div style={{ paddingTop: 20 }}>
    <CommonSettings
      permissions={props.permissions}
      record={props.record}
      resource={props.resource} />

    <div style={{ display: 'flex', paddingTop: 20 }}>
      <div style={{ flex: 1, paddingRight: 15 }}>
        <Field
          allowEmpty
          className={props.classes.bidders}
          component={ReferenceArrayInput}
          label="RTB Bidders *"
          name="bidders"
          record={props.record}
          reference="helpers/bidders"
          resource="campaign_rtbs"
          sort={{ field: 'name', order: 'ASC' }}
          source="bidders"
          validate={ValidateRequired}
        >
          <Field
            component={SelectArrayInput}
            label="RTB Bidders"
            name="bidders"
            source="bidders" />
        </Field><br />
        <Field
          choices={rtbDomainsDropdown()}
          component={SelectArrayInput}
          label="End Points"
          name="domains"
          source="domains" /><br />
      </div>
      <div style={{ flex: 1, paddingLeft: 15 }}>
        <Field
          component={NumberInput}
          label="Bidding Floor"
          name="bidding_floor"
          source="bidding_floor" /><br />
        <PaceInputs />
      </div>
    </div><br />

    <div style={{ display: 'flex', border: '1px solid rgba(0, 0, 0, 0.1)', padding: 25 }}>
      <div style={{ flex: 1 }}>
        <Field
          component={BooleanInput}
          label="Experimental"
          name="experiments.experimental"
          source="experiments.experimental"
          style={{ width: '0' }} />
        <FormDataConsumer>
          {({ formData, ...rest }) => CanViewExperimentId(formData) &&
            <span>Experiment ID: {props.record.experiments && props.record.experiments.experiment_id}</span>
          }
        </FormDataConsumer>
      </div>
      <FormDataConsumer>
        {({ formData, ...rest }) => CanViewExperimentName(formData) &&
          <div style={{ flex: 1 }}>
            <Field
              className={props.classes.experimentName}
              component={TextInput}
              label="Experiment Name"
              name="experiments.experiment_name"
              source="experiments.experiment_name" /><br />
          </div>
        }
      </FormDataConsumer>
    </div>
  </div>
);

export default withStyles(styles)(SettingsTab);



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Rtb/Partials/SettingsTab.tsx